// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"195a6d64","519":"086a2736"}[chunkId] + ".chunk.js";
};